import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import './cardInfo.css';

const cardInfo = (props) => {
    const {bordercolor, title, icon, iconsize, info1,info2} = props;
    return(
        <div className="containerCard" style={{borderColor:bordercolor}}>
            <div className="textCard">
                <h3 id="titleCard">{title}</h3>
                <h2>{info1}</h2>
                <h2>{info2}</h2>
            </div>
        </div>
    )
}

export default cardInfo;